import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M3.429 0A3.43 3.43 0 0 0 0 3.429V20.57A3.43 3.43 0 0 0 3.429 24H20.57A3.43 3.43 0 0 0 24 20.571V3.43A3.43 3.43 0 0 0 20.571 0zm15.916 4.5-5.561 6.354 6.541 8.646h-5.121l-4.008-5.245-4.59 5.245H4.06l5.946-6.798L3.734 4.5h5.25l3.627 4.795L16.8 4.5zM17.32 17.979 8.218 5.94H6.702l9.203 12.038h1.415"
    }, null, -1)
  ])))
}
export default { render: render }